import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/integrations/supabase/client'
import { Users } from 'lucide-react'
import { ConorbitLoader } from '@/components/ui/ConorbitLoader'
import { OrgProfileView } from './OrgProfileView'

export function ConorbitTeamView() {
  const { data: platformOrg, isLoading } = useQuery({
    queryKey: ['platform-owner-org'],
    queryFn: async () => {
      const { data, error } = await (supabase
        .from('organizations' as any)
        .select('id, name')
        .filter('settings->>is_platform_owner', 'eq', 'true')
        .maybeSingle() as any)
      if (error) throw error
      return data as { id: string; name: string } | null
    }
  })

  if (isLoading) return <ConorbitLoader variant="inline" />

  if (!platformOrg) return (
    <div className="rounded-xl border border-amber-200 bg-amber-50 p-6 text-sm text-amber-800 space-y-1">
      <p className="text-justify font-semibold">Platform organisation not found.</p>
      <p className="text-justify text-[12px]">
        The CONORBIT platform organisation has not been seeded in the database.
        Contact your database administrator to add a row to <code>organizations</code> with{' '}
        <code>{"settings->>'is_platform_owner' = 'true'"}</code>.
      </p>
    </div>
  )

  return (
    <div className="space-y-4">
      <div>
        <div className="flex items-center gap-2 mb-0.5">
          <Users size={16} className="text-[#0D2240]" />
          <h2 className="text-lg font-semibold text-[#0D2240]">CONORBIT Team</h2>
        </div>
        <p className="text-justify text-xs text-muted-foreground max-w-xl">
          Manage the internal CONORBIT organisation. Appoint the CONORBIT Institution Admin here, they will
          receive full Institution Admin dashboard access for the CONORBIT organisation. The Platform Administrator role
          is separate and operates at the platform level.
        </p>
      </div>

      <OrgProfileView orgId={platformOrg.id} />
    </div>
  )
}
